// Used to find the user who is reported
export const getReportedByUser = (task) => {
  if (task.requestedBy === 'Homeowner') {
    return task.homeowner;
  } else if (task.requestedBy === 'Resident') {
    return task.resident;
  }
};
